import React from 'react';

class Breadcrumbs extends React.Component{

    static defaultProps = {
        items: [{label:"Home",link:"/"},{label:"Active",link:"."}],
        activeIndex: 1,
        className: ""
    };
    
    render(){
        const { items, activeIndex, className } = this.props;
        return (
            <nav aria-label="breadcrumb" className={className}>
              <ol className="breadcrumb mb-0">
                {items && items.length > 0 ? items.map((item,key) =>
                    (
                      <li className={(key===activeIndex)?'breadcrumb-item active':'breadcrumb-item'} key={key}><a href={item.link}>{item.label}</a></li>
                    )
                  ):null}
              </ol>
            </nav>
        );
    }
}

export default Breadcrumbs;
